export default __webpack_public_path__ + "static/media/2.a1fac40d.png";